import { Component, OnInit, ViewChild } from '@angular/core';
import { Practice } from 'src/app/models/practice';
import { PracticeService } from 'src/app/services/practice.service';
import { ActivatedRoute, Router } from '@angular/router';
import { MemberService } from 'src/app/services/member.service';
import { NotificationService } from 'src/app/services/notification.service';
import { MatTableDataSource, MatPaginator } from '@angular/material';

@Component({
  selector: 'app-mentors',
  templateUrl: './mentors.component.html',
  styleUrls: ['./mentors.component.scss']
})
export class MentorsComponent implements OnInit {
  public practice: Practice;
  public practiceId;
  public mentorId;
  public mentor;
  public loadedMentor:boolean=false;
  public loadedPractice:boolean=false;
  public newMentorEmailAddress:string='';public datasource:MatTableDataSource<any>;
  displayedColumns: string[] = ['first_name', 'last_name', 'email', 'students', 'viewMentor','removeMentor'];
  @ViewChild(MatPaginator, {static: true}) paginator: MatPaginator;

  constructor(
    private _practice: PracticeService,
    private _route: ActivatedRoute,
    private _member: MemberService,
    private _notify: NotificationService,
    private _router: Router
  ) {
    this.practiceId = this._route.snapshot.paramMap.get("practiceId");
    this.mentorId = this._route.snapshot.paramMap.get("id");
  }

  public getMentor(){
    this._member.getMember(this.mentorId).subscribe(
      res=>{
        this.mentor=res;
        this.loadedMentor=true;
      }
    );
  }

  public inviteMentor(){
    if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(this.newMentorEmailAddress))
    {
      this._practice.invitePracticeMentor(this.practiceId, this.newMentorEmailAddress).subscribe(
        (res:any)=>{
          if(res.message){
            this._notify.showMessage(res.message, 'OK');
          } else {
            this.getPractice();
            this._notify.showMessage('Mentor has been invited.','OK');
          }
        }
      );
    } else {
      this._notify.showMessage("Please enter a valid email address", "OK");
    }
  }

  public getPractice(){
    this._practice.getPractice(this.practiceId).subscribe(
      res=>{
        this.practice=new Practice(res);
        this.loadedPractice=true;
        this.datasource = new MatTableDataSource<any>(this.practice.mentors);
        this.datasource.paginator=this.paginator;
      }
    );
  }

  public removePracticeMentor(){
    if(confirm('Confirm removal of this mentor. This will remove the mentor from your practice and unassign them from all currently associated practice members.')){
      this._practice.removePracticementor(this.practiceId, this.mentorId).subscribe(
        res=>{
          this._notify.showMessage('Mentor has been removed', 'OK');
          this._router.navigate(['/practices/'+this.practiceId+'/mentors']);
        }
      );
    }
  }

  public resendInvite(inviteId:number){
    this._practice.reinvitePracticeMentor(inviteId).subscribe(
      res=>{
        this._notify.showMessage(res.message, 'OK');
      }
    );
  }

  public cancelInvite(inviteId:number){
    if(confirm('Are you sure that you want to cancel this Mentor Invitation?')){
      this._practice.cancelPracticeMentorInvite(inviteId).subscribe(
        res=>{
          this._notify.showMessage(res.message, 'OK');
          this.getPractice();
        }
      );
    }
  }

  goToMember(mentor:any){
    //build me
  }

  removeMentor(id:number){
    if(confirm('Confirm removal of this Mentor from your practice and all associated students.')){
      this._practice.removePracticementor(this.practice.id, id).subscribe(
        res=>{
          this._notify.showMessage(res.message, 'OK');
          this.getPractice();
        }
      );
    }
  }

  ngOnInit() {
    this.getPractice();
    if(this.mentorId) this.getMentor();
  }
}
